import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "d-flex justify-center pb-3" }
const _hoisted_2 = { class: "d-flex justify-space-around pt-3 pb-3" }
const _hoisted_3 = { class: "d-flex justify-space-around pt-3 pb-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_toolbar_title = _resolveComponent("v-toolbar-title")!
  const _component_v_toolbar = _resolveComponent("v-toolbar")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_card_subtitle = _resolveComponent("v-card-subtitle")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card_actions = _resolveComponent("v-card-actions")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createBlock(_component_v_card, null, {
    default: _withCtx(() => [
      _createVNode(_component_v_toolbar, {
        dark: "",
        color: "primary",
        tile: "",
        flat: "",
        class: "mb-5"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_btn, {
            icon: "",
            dark: "",
            onClick: _ctx.close
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_icon, null, {
                default: _withCtx(() => [...(_cache[3] || (_cache[3] = [
                  _createTextVNode("mdi-close", -1)
                ]))]),
                _: 1
              })
            ]),
            _: 1
          }, 8, ["onClick"]),
          _createVNode(_component_v_toolbar_title, null, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(_ctx.$t('absence.deleteTitle')), 1)
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.chatsAbsence, (absence, index) => {
        return (_openBlock(), _createElementBlock("div", {
          key: `${index}-absence`,
          class: "mb-5"
        }, [
          _createVNode(_component_v_card, { class: "mx-5" }, {
            default: _withCtx(() => [
              _createVNode(_component_v_card_title, null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('common.date')) + "：" + _toDisplayString(_ctx.formatAbsenceDate(absence.date)), 1)
                ]),
                _: 2
              }, 1024),
              _createVNode(_component_v_card_subtitle, { class: "mt-2" }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('absence.reason')), 1)
                ]),
                _: 1
              }),
              (absence.absenceDetails)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                    _createVNode(_component_v_card_text, { style: {"white-space":"pre-wrap"} }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.showReason(absence.absenceDetails.reason)), 1)
                      ]),
                      _: 2
                    }, 1024),
                    (absence.absenceDetails.comment)
                      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                          _createVNode(_component_v_card_subtitle, null, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(_ctx.$t('absence.comment')), 1)
                            ]),
                            _: 1
                          }),
                          _createVNode(_component_v_card_text, { style: {"white-space":"pre-wrap"} }, {
                            default: _withCtx(() => [
                              _createTextVNode(_toDisplayString(absence.absenceDetails.comment), 1)
                            ]),
                            _: 2
                          }, 1024)
                        ], 64))
                      : _createCommentVNode("", true)
                  ], 64))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_1, [
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      color: "error",
                      depressed: "",
                      onClick: ($event: any) => (_ctx.isDeleteAbsence(absence)),
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('absence.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["onClick"])
                  ]),
                  _: 2
                }, 1024)
              ]),
              _createVNode(_component_v_divider)
            ]),
            _: 2
          }, 1024)
        ]))
      }), 128)),
      _createVNode(_component_v_dialog, {
        modelValue: _ctx.deleteDialog,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.deleteDialog) = $event)),
        class: "delete-absence-dialog"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_card, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createVNode(_component_v_card_title, { class: "headline lighten-2" }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.$t('common.deleteConfirm')), 1)
                  ]),
                  _: 1
                })
              ]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_component_v_card_actions, null, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_btn, {
                      onClick: _cache[0] || (_cache[0] = () => (_ctx.deleteDialog = false)),
                      variant: "text"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.cancel')), 1)
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_btn, {
                      color: "error",
                      class: "ml-5",
                      depressed: "",
                      onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.deleteAbsence())),
                      loading: _ctx.deleteLoading,
                      variant: "flat"
                    }, {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('common.delete')), 1)
                      ]),
                      _: 1
                    }, 8, ["loading"])
                  ]),
                  _: 1
                })
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _: 1
  }))
}